const AppSettings = {
  appTitle: 'SGS Manager',
  appName: 'sgs_manager',
  apiUrl: {
    restRoot: 'http://api.sa21c.com/',  //서버용
    //restRoot: 'http://api.sa21c.com:8080/', //개발용
    publicRestRoot: 'http://api.sa21c.com/', //이미지용
    // publicRestRoot: 'http://api.sa21c.com:8080/', //이미지용
    development: 'http://kictpoe.linkit.me/pages/proxy.php',
    production: './proxy.php',
    geocode: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyA-69jPVeSZnPqLeGoPf9Xcz0MQMH7GprY&new_forward_geocoder=true&address=',
    kmaWeather: 'http://newsky2.kma.go.kr/service/SecndSrtpdFrcstInfoService2/ForecastGrib',
    juso: 'http://www.juso.go.kr/addrlink/addrLinkApi.do'
  },
  apiKey: {
    kma: 'lMHlHNjHbdW5mqKPodpohfpNGIfBX0L%2BM6PnsFNNg9ISr4AYtaCTsW%2FI8HVueeRg55NXCtGm7K1YFvx1c5P5aQ%3D%3D',  // 기상청 날씨 조회, data.go.kr 아이디 master@linkit.kr
    fineDust: 'lMHlHNjHbdW5mqKPodpohfpNGIfBX0L%2BM6PnsFNNg9ISr4AYtaCTsW%2FI8HVueeRg55NXCtGm7K1YFvx1c5P5aQ%3D%3D', // 미세먼지, data.go.kr 아이디 master@linkit.kr
    juso: 'U01TX0FVVEgyMDE4MDMxNzAwMjYxMTEwNzczNTE=', // 도로명주소 API
    youtube: 'AIzaSyD0InW9sj-fz24ZctoXQa9KaRqXvxi-QSI'  // google cloud api 아이디 linkitkr@gmail.com
  },
  location: {
    fieldWidth: 1220,
    fieldHeight: 880,
    //fieldHeight: 680,    // 위의 880이 원래 축구장 이미지 크기에 맞는 비유이지만 경기분석 화면이 한 화면에 들어오지 않아 높이를 조정함
    halfFieldWidth: 957,
    halfFieldHeight: 635,
    smallFieldWidth: 740,
    smallFieldHeight: 555
  },
  userTypes: [
    { userTypeId: '12', userType: 'team_manager', name: '팀매니저', loginId: 'team_manager@kfa.or.kr', passwd: 'sa21c' },
    { userTypeId: '1', userType: 'player', name: '테스트', loginId: 'sgs.testuser001@gmail.com', passwd: '12345678' },
    { userTypeId: '1', userType: 'player', name: '권순태', loginId: 'kwounsuntae@kfa.or.kr', passwd: '12345678' },
    // { userTypeId: '10', userType: 'leader', name: '단장', loginId: 'user_type_10@test.com', passwd: 'sa21c' },
    // { userTypeId: '4', userType: 'director', name: '감독', loginId: 'user_type_4@test.com', passwd: 'sa21c' },
    // { userTypeId: '5', userType: 'coach', name: '필드코치', loginId: 'user_type_5@test.com', passwd: 'sa21c' },
    // { userTypeId: '6', userType: 'gk_coach', name: 'GK코치', loginId: 'user_type_6@test.com', passwd: 'sa21c' },
    // { userTypeId: '9', userType: 'analyst', name: '전력분석관', loginId: 'user_type_9@test.com', passwd: 'sa21c' },
    // { userTypeId: '13', userType: 'medical_staff', name: '의료진', loginId: 'user_type_13@test.com', passwd: 'sa21c' },
    // { userTypeId: '8', userType: 'rehabilitation_trainer', name: '재활트레이너', loginId: 'user_type_8@test.com', passwd: 'sa21c' },
    // { userTypeId: '7', userType: 'physical_coach', name: '피지컬코치', loginId: 'user_type_7@test.com', passwd: 'sa21c' },
    // { userTypeId: '17', userType: 'fan', name: '팬', loginId: 'user_type_17@test.com', passwd: 'sa21c' },
    // { userTypeId: '16', userType: 'staff', name: '운영스탭', loginId: 'user_type_16@test.com', passwd: 'sa21c' },
    // { userTypeId: '25', userType: 'association', name: '협회', loginId: 'user_type_25@test.com', passwd: 'sa21c' }
  ],
  bioItems: [

    {
      name: '부상',
      type: 'injury',
      selected: false
    },
    {
      name: '체중',
      type: 'weight',
      selected: false
    },
    {
      name: '수면',
      type: 'sleep',
      selected: false
    },
    {
      name: '수분',
      type: 'water',
      selected: false
    },
    {
      name: '소모',
      type: 'caloryburn',
      selected: false
    },
    {
      name: '섭취',
      type: 'caloryget',
      selected: false
    },
    {
      name: '거리',
      type: 'distance',
      selected: false
    },
    {
      name: '속도',
      type: 'velocity',
      selected: false
    },
    {
      name: '심박수',
      type: 'heartbeat',
      selected: false
    },
    {
      name: 'SpO2',
      type: 'oxyzen',
      selected: false
    },
    {
      name: '젖산',
      type: 'lactic',
      selected: false
    },
    
    {
      name: '체온',
      type: 'temperature',
      selected: false
    },
    {
      name: '폐활량',
      type: 'lung_capacity_1',
      selected: false
    },
    {
      name: '동작',
      type: 'location',
      selected: false
    }
    
  ],
  langCode: {
    '한국어': 'ko',
    '갈리시아어': '',
    '구자라트어': '',
    '그리스어': 'el',
    '네덜란드어': '',
    '네팔어': '',
    '노르웨이어': '',
    '덴마크어': '',
    '독일어': 'de',
    '라오어': '',
    '라트비아어': '',
    '라틴어': 'la',
    '러시아어': 'ru',
    '루마니아어': 'ro',
    '룩셈부르크어': '',
    '리투아니아어': '',
    '마라티어': '',
    '마오리어': '',
    '마케도니아어': '',
    '말라가시어': '',
    '말라얄람어': '',
    '말레이어': '',
    '몰타어': '',
    '몽골어': '',
    '몽어': '',
    '미얀마어 (버마어)': 'my',
    '바스크어': '',
    '베트남어': 'vi',
    '벨라루스어': '',
    '벵골어': '',
    '보스니아어': '',
    '불가리아어': '',
    '사모아어': '',
    '세르비아어': '',
    '세부아노': '',
    '세소토어': '',
    '소말리아어': '',
    '쇼나어': '',
    '순다어': '',
    '스와힐리어': '',
    '스웨덴어': '',
    '스코틀랜드 게일어': '',
    '스페인어': 'es',
    '슬로바키아어': '',
    '슬로베니아어': '',
    '신디어': '',
    '신할라어': '',
    '아랍어': 'ar',
    '아르메니아어': '',
    '아이슬란드어': '',
    '아이티 크리올어': '',
    '아일랜드어': '',
    '아제르바이잔어': '',
    '아프리칸스어': '',
    '알바니아어': '',
    '암하라어': '',
    '에스토니아어': 'et',
    '에스페란토어': '',
    '영어': 'en',
    '요루바어': '',
    '우르두어': '',
    '우즈베크어': '',
    '우크라이나어': '',
    '웨일즈어': '',
    '이그보어': '',
    '이디시어': '',
    '이탈리아어': 'it',
    '인도네시아어': '',
    '일본어': 'ja',
    '자바어': '',
    '조지아어': '',
    '줄루어': '',
    '중국어(간체)': 'zh-CN',
    '중국어(번체)': 'zh-TW',
    '체와어': '',
    '체코어': '',
    '카자흐어': '',
    '카탈로니아어': 'ca',
    '칸나다어': '',
    '코르시카어': '',
    '코사어': '',
    '쿠르드어': '',
    '크로아티아어': '',
    '크메르어': '',
    '키르기스어': '',
    '타갈로그어': '',
    '타밀어': '',
    '타지크어': '',
    '태국어': 'th',
    '터키어': 'tr',
    '텔루구어': '',
    '파슈토어': '',
    '펀자브어': '',
    '페르시아어': '',
    '포르투갈어': 'pt',
    '폴란드어': '',
    '프랑스어': 'fr',
    '프리지아어': '',
    '핀란드어': '',
    '하와이어': '',
    '하우사어': '',
    '헝가리어': '',
    '히브리어': '',
    '힌디어': 'hi'
  },
  payInfo: {
    team: [
      {
        product: 'SGS TEAM USER',
        productName: 'TS 700',
        service: '인공지능 기술 동작 측정 + 인공지능 EPTS 서비스 연동형 버전 - 바로 결제도 가능하며, PS 7 사용자가 55명일 경우 팀 서비스를 사용 가능합니다.',
        unitPrice: 1500000,
        unitPriceUSD: 1500,
        quantity: 12,
        deviceUnitPrice: 3300000,
        deviceUnitPriceUSD: 3300,
        deviceQuantity: 11,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS 스마트 가드',
        productName: '스마트 가드 700',
        service: '인공지능 기술 동작 측정 서비스 + 인공지능 EPTS ',
        unitPrice: 3300000,
        unitPriceUSD: 3300,
        quantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS TEAM USER',
        productName: 'TS 70',
        service: '인공지능 기술 동작 측정 서비스 연동형 버전 - 바로 결제도 가능하며, PS 7 사용자가 35명일 경우 팀 서비스를 사용 가능합니다.',
        unitPrice: 700000,
        unitPriceUSD: 700,
        quantity: 1,
        deviceUnitPrice: 1100000,
        deviceUnitPriceUSD: 1100,
        deviceQuantity: 11,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS 스마트 가드',
        productName: '스마트 가드 70',
        service: '인공지능 기술 동작 측정 서비스',
        unitPrice: 1100000,
        unitPriceUSD: 1100,
        quantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS TEAM USER',
        productName: 'TS 7',
        service: 'TS7은 데이터기록분석서비스 버전 - 바로 결제도 가능하며, PS 7 사용자가 15명일 경우 팀 서비스를 사용 가능합니다.',
        unitPrice: 300000,
        unitPriceUSD: 300,
        quantity: 1,
        deviceUnitPrice: 250000,
        deviceUnitPriceUSD: 250,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      // {
      //   product: 'SGS 스마트 가드',
      //   productName: '스마트 가드 EPTS용',
      //   service: '스마트 웨어러블 가드',
      //   unitPrice: 3000000,
      //   unitPriceUSD: 3000,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // },
      // {
      //   product: 'SGS 스마트 가드',
      //   productName: '스마트 가드 프로페셔널용',
      //   service: '스마트 웨어러블 가드',
      //   unitPrice: 2000000,
      //   unitPriceUSD: 2000,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // },
      
      
      // , {
      //   product: 'SGS TOKEN',
      //   productName: 'SGS TOKEN',
      //   service: 'SGS 플랫폼에서만 통용되는 가상화폐',
      //   unitPrice: 2100000,
      //   unitPriceUSD: 2100,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // }
    ],
    player: [
      {
        product: 'SGS PLAYER USER',
        productName: 'PS 700',
        service: '인공지능 기술 동작 측정 + 인공지능 EPTS 서비스 연동형 버전',
        unitPrice: 300000,
        unitPriceUSD: 300,
        quantity: 1,
        deviceUnitPrice: 350000,
        deviceUnitPriceUSD: 350,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS 스마트 가드',
        productName: '스마트 가드 700',
        service: '인공지능 기술 동작 측정 서비스 + 인공지능 EPTS 서비스',
        unitPrice: 3300000,
        unitPriceUSD: 3300,
        quantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS PLAYER USER',
        productName: 'PS 70',
        service: '인공지능 기술 동작 측정 서비스 연동형 버전',
        unitPrice: 150000,
        unitPriceUSD: 150,
        quantity: 1,
        deviceUnitPrice: 250000,
        deviceUnitPriceUSD: 250,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS 스마트 가드',
        productName: '스마트 가드 70',
        service: '인공지능 기술 동작 측정 서비스',
        unitPrice: 1100000,
        unitPriceUSD: 1100,
        quantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS PLAYER USER',
        productName: 'PS 7',
        service: 'PS7은 데이터기록분석서비스 버전',
        unitPrice: 20000,
        unitPriceUSD: 20,
        quantity: 1,
        deviceUnitPrice: 250000,
        deviceUnitPriceUSD: 250,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      }
      // {
      //   product: 'SGS 스마트 가드',
      //   productName: '스마트 가드 EPTS용',
      //   service: '스마트 웨어러블 가드',
      //   unitPrice: 3000000,
      //   unitPriceUSD: 3000,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // },
      // {
      //   product: 'SGS 스마트 가드',
      //   productName: '스마트 가드 프로페셔널용',
      //   service: '스마트 웨어러블 가드',
      //   unitPrice: 2000000,
      //   unitPriceUSD: 2000,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // },
      
      
      // , {
      //   product: 'SGS TOKEN',
      //   productName: 'SGS TOKEN',
      //   service: 'SGS 플랫폼에서만 통용되는 가상화폐',
      //   unitPrice: 2100000,
      //   unitPriceUSD: 2100,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // }
    ],
    fan: [
      {
        product: 'SGS FAN USER',
        productName: 'FS 700',
        service: 'FS700은 데이터기록분석 인공지능 기술 동작 측정 + 인공지능 EPTS 모니터링서비스 버전',
        unitPrice: 30000,
        unitPriceUSD: 10,
        quantity: 1,
        deviceUnitPrice: 250000,
        deviceUnitPriceUSD: 250,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS 스마트 가드',
        productName: '스마트 가드 700',
        service: '인공지능 기술 동작 측정 서비스 + 인공지능 EPTS 서비스',
        unitPrice: 3300000,
        unitPriceUSD: 3300,
        quantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS FAN USER',
        productName: 'FS 70',
        service: 'FS700은 데이터기록분석 인공지능 기술 동작 측정 모니터링서비스 버전',
        unitPrice: 20000,
        unitPriceUSD: 10,
        quantity: 1,
        deviceUnitPrice: 250000,
        deviceUnitPriceUSD: 250,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS 스마트 가드',
        productName: '스마트 가드 70',
        service: '인공지능 기술 동작 측정 서비스',
        unitPrice: 1100000,
        unitPriceUSD: 1100,
        quantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      },
      {
        product: 'SGS FAN USER',
        productName: 'FS 7',
        service: 'FS7은 데이터기록분석 모니터링서비스 버전',
        unitPrice: 10000,
        unitPriceUSD: 10,
        quantity: 1,
        deviceUnitPrice: 250000,
        deviceUnitPriceUSD: 250,
        deviceQuantity: 1,
        promotion: {
          text: '',
          price: 0,
          priceUSD: 0
        }
      }
      // , {
      //   product: 'SGS TOKEN',
      //   productName: 'SGS TOKEN',
      //   service: 'SGS 플랫폼에서만 통용되는 가상화폐',
      //   unitPrice: 2100000,
      //   unitPriceUSD: 2100,
      //   quantity: 1,
      //   promotion: {
      //     text: '',
      //     price: 0,
      //     priceUSD: 0
      //   }
      // }
    ]
  },
  promotionCode: 'sa21c'
};

export default AppSettings;
